import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Clock, LogOut, RefreshCw } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;

export default function PendingActivation() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(false);
  const user = JSON.parse(localStorage.getItem('unified_user') || localStorage.getItem('user') || '{}');

  useEffect(() => {
    // If no user or user is already approved, redirect
    if (!user?.username) {
      navigate('/auth/login');
    }
  }, [user, navigate]);

  const checkStatus = async () => {
    setChecking(true);
    const token = localStorage.getItem('unified_token');
    try {
      const res = await axios.get(`${API_URL}/api/auth/unified/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const updatedUser = res.data.user;
      if (updatedUser?.status === 'approved' || updatedUser?.status === 'active') {
        // Update stored user and redirect
        localStorage.setItem('unified_user', JSON.stringify(updatedUser));
        localStorage.setItem('user', JSON.stringify({ ...updatedUser, token }));
        navigate('/module-selector');
      }
    } catch {
      // Token might be expired
    }
    setChecking(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('unified_token');
    localStorage.removeItem('unified_user');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/auth/login');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0F172A] via-[#1E293B] to-[#0F172A] flex items-center justify-center p-4" data-testid="pending-activation-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/">
            <h1 className="text-3xl font-bold text-white tracking-tight">Stay<span className="text-[#2563EB]">Mii</span></h1>
          </Link>
        </div>

        <Card className="bg-white/10 backdrop-blur-lg border-white/20">
          <CardHeader className="text-center pb-2">
            <div className="mx-auto w-16 h-16 bg-amber-500/20 rounded-full flex items-center justify-center mb-4">
              <Clock className="w-8 h-8 text-amber-400" />
            </div>
            <CardTitle className="text-white text-xl">Account Being Activated</CardTitle>
            <CardDescription className="text-slate-300 mt-3 leading-relaxed">
              Welcome, <span className="text-white font-medium">{user?.full_name || user?.username}</span>! 
              Your account is currently under review. Our admin team will activate your account shortly.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4 pt-2">
            <div className="bg-amber-500/10 border border-amber-500/20 rounded-lg p-4">
              <p className="text-amber-200 text-sm leading-relaxed">
                You'll receive an email notification once your account has been approved. 
                You can also check your status by clicking the button below.
              </p>
            </div>

            <Button
              onClick={checkStatus}
              disabled={checking}
              className="w-full bg-[#2563EB] hover:bg-[#1D4ED8] text-white"
              data-testid="check-status-btn"
            >
              {checking ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <RefreshCw className="w-4 h-4 mr-2" />}
              Check Activation Status
            </Button>

            <button
              onClick={handleLogout}
              className="w-full text-slate-500 hover:text-white text-sm flex items-center justify-center gap-1.5 transition-colors py-2"
              data-testid="pending-logout-btn"
            >
              <LogOut className="w-3.5 h-3.5" /> Sign out
            </button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
